export const CSSFixedColumns = {
    WORKER_DNI: {
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        paddingLeft: 10,
        paddingRight: 10,
    },
    WORKER_NAME: {
        minWidth: 250,
        maxWidth: 250,
        width: 250,
        paddingLeft: 10,
        paddingRight: 10,
    },
    WORKER_COMPANY: {
        minWidth: 250,
        maxWidth: 250,
        width: 250,
        paddingLeft: 10,
        paddingRight: 10,
    },
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/components/table/CssFixedColumns.js